import makeStateFilter from '../../../make-state-filter';

import { stateFilter as parentStateFilter } from '../ltl.reducer.metadata';

const namespace = 'core';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
